// Sprachpaket Deutsch – Website-Texte (wird immer mit dem Hauptbundlegeladen)
export default {
  nav: {
    home: "Start",
    properties: "Ferienobjekte",
    islands: "Inseln",
    about: "Über uns",
    contact: "Kontakt",
    deals: "Angebote",
    admin: "Admin",
    tips: "Reisetipps",
    landlord: "Vermieter",
    customer: "Meine Buchungen",
    allProperties: "Alle Ferienobjekte",
    apartments: "Ferienwohnungen",
    houses: "Ferienhäuser",
    complexes: "Fincas & Anlagen"
  },
  island: {
    badge: "Kanarische Inseln · Reiseziel",
    showAll: "Alle Objekte auf {n} anzeigen",
    properties: "Ferienobjekte auf {n}",
    none: "Derzeit keine Objekte auf dieser Insel – schauen Sie bald wieder vorbei.",
    nonePlace: "Derzeit keine Objekte in {n} –",
    nonePlaceLink: "hier alle Objekte auf {n} ansehen",
    others: "Weitere Inseln entdecken",
    faq: "Häufige Fragen",
    places: "Orte auf {n}",
    placeBadge: "Urlaubsort",
    backToIsland: "Alle Objekte auf {n}",
    highlights: "Sehenswert in und um {n}"
  },
  newsletter: {
    badge: "Newsletter",
    title: "Neue Ferienobjekte per E-Mail",
    text: "Wir informieren Sie, sobald neue Objekte online gehen – kostenlos, jederzeit abbestellbar.",
    email: "Ihre E-Mail-Adresse",
    allIslands: "Alle Inseln",
    submit: "Anmelden",
    sent: "Fast geschafft! Bitte bestätigen Sie den Link in Ihrer E-Mail.",
    already: "Sie sind bereits angemeldet.",
    privacy: "Mit der Anmeldung stimmen Sie dem Erhalt unseres Newsletters zu. Abmeldung jederzeit über den Link in jeder E-Mail.",
    confirmed: "Vielen Dank – Ihre Newsletter-Anmeldung ist bestätigt!",
    unsubscribed: "Sie wurden vom Newsletter abgemeldet.",
    invalid: "Dieser Link ist ungültig oder abgelaufen."
  },
  hero: {
    badge: "Kanarische Inseln · Handverlesen",
    title: "Ferienwohnungen & Ferienhäuser auf den Kanaren",
    titleAccent: "zwischen Ozean und Vulkanen",
    seoTitle: "Ferienwohnungen & Ferienhäuser Kanaren | privateHOLIDAY",
    seoDescription: "Ferienwohnungen, Ferienhäuser, Villen & Fincas auf Teneriffa, Gran Canaria, Lanzarote, Fuerteventura, La Palma & La Gomera – privat, direkt vom Vermieter, ohne Portalgebühren.",
    subtitle: "Sorgfältig ausgewählte Ferienobjekte auf allen acht Kanaren – von der luxuriösen Villa bis zur charmanten Finca.",
    searchIsland: "Insel wählen",
    allIslands: "Alle Inseln",
    checkin: "Anreise",
    checkout: "Abreise",
    guests: "Gäste",
    search: "Suchen",
    selectDate: "Datum wählen",
    pickCheckin: "Anreisetag wählen",
    pickCheckout: "Abreisetag wählen",
    closeBtn: "Schließen"
  },
  contact: {
    title: "Kontakt",
    metaDesc: "Kontaktieren Sie privateHOLIDAY – Ihre Vermittlungsagentur für Ferienhäuser auf den Kanaren. Telefon, E-Mail, Sprechzeiten und Bürostandort.",
    intro: "Sie haben Fragen zu einem Objekt, zur Buchung oder möchten Ihr Ferienhaus über uns vermieten? Schreiben Sie uns – wir antworten in der Regel innerhalb eines Werktags.",
    name: "Ihr Name",
    email: "Ihre E-Mail",
    phone: "Telefon (optional)",
    subject: "Betreff",
    message: "Ihre Nachricht",
    send: "Nachricht senden",
    privacy: "Ihre Daten werden nur zur Bearbeitung Ihrer Anfrage verwendet.",
    sentTitle: "Vielen Dank für Ihre Nachricht!",
    sentText: "Wir haben Ihre Anfrage erhalten und melden uns schnellstmöglich. Eine Kopie wurde an Ihre E-Mail-Adresse gesendet.",
    phoneLabel: "Telefon",
    emailLabel: "E-Mail",
    hours: "Telefonische Sprechzeiten",
    hoursNote: "Als Internetunternehmen betreiben wir kein Ladengeschäft – persönliche Termine nur nach telefonischer Vereinbarung.",
    address: "Bürostandort"
  },
  priceAlert: {
    button: "Preisalarm",
    title: "Preisalarm für Ihre Merkliste",
    text: "Wir schicken Ihnen eine E-Mail, sobald eines Ihrer {n} gemerkten Objekte ein Last-Minute-Angebot bekommt.",
    submit: "Preisalarm aktivieren",
    success: "Preisalarm aktiviert – wir melden uns, sobald ein Angebot verfügbar ist."
  },
  legal: {
    impressum: "Impressum",
    privacy: "Datenschutz",
    terms: "Vermittlungsbedingungen",
    privacyLong: "Datenschutzerklärung",
    acceptTerms: "Ja, ich erkenne die Vermittlungsbedingungen an.",
    acceptPrivacy: "Ja, ich erkenne die Datenschutzerklärung an.",
    show: "{name} anzeigen",
    acceptRequired: "Bitte bestätigen Sie die Vermittlungsbedingungen und die Datenschutzerklärung.",
    onlyGerman: "Dieser Text liegt derzeit nur auf Deutsch vor.",
    bannerTitle: "Datenschutz-Hinweis",
    bannerText: "Wir verwenden keine Tracking-Cookies. Für Sprache, Merkliste und letzte Suche speichern wir Daten nur lokal in Ihrem Browser. Mehr dazu in unserer",
    bannerOk: "Verstanden"
  },
  islands: {
    title: "Die acht Inseln",
    subtitle: "Acht Welten – ein Archipel",
    tenerife: "Teneriffa",
    "gran-canaria": "Gran Canaria",
    fuerteventura: "Fuerteventura",
    lanzarote: "Lanzarote",
    "la-palma": "La Palma",
    "la-gomera": "La Gomera",
    "el-hierro": "El Hierro",
    "la-graciosa": "La Graciosa"
  },
  usps: [
    {
      title: "Sofortbuchung",
      text: "Bestätigung binnen Sekunden — SMS an Vermieter inklusive."
    },
    {
      title: "Alle 8 Inseln",
      text: "Von den Vulkanen Lanzarotes bis zu den Stränden La Graciosas."
    },
    {
      title: "Bewertungen",
      text: "Echte Gästestimmen nach jedem Aufenthalt – ungefiltert und überprüft. [Alle Gästestimmen lesen →](/bewertungen)"
    },
    {
      title: "{amount} Neukunden-Gutschein",
      text: "Bei Ihrer ersten Buchung sparen Sie {amount} — einfach Code {code} beim Buchen eingeben."
    }
  ],
  featured: {
    title: "Ausgewählte Ferienobjekte",
    subtitle: "Die schönsten Häuser dieser Woche",
    badge: "Empfehlung",
    showAll: "Alle Ferienobjekte anzeigen"
  },
  complex: {
    badge: "Anlage / Finca",
    sharedAmenities: "Gemeinsame Ausstattung der Anlage",
    unitsBadge: "Wohneinheiten",
    unitsTitle: "{n} Unterkünfte in dieser Anlage",
    noUnits: "Derzeit keine Unterkünfte verfügbar.",
    partOf: "Teil der Anlage",
    seeAll: "Alle {n} Unterkünfte der Anlage ansehen",
    kindName: {
      finca: "Finca",
      complex: "Anlage"
    },
    unitsOne: {
      finca: "1 Unterkunft auf dieser Finca",
      complex: "1 Unterkunft in dieser Anlage"
    },
    unitsMany: {
      finca: "{n} Unterkünfte auf dieser Finca",
      complex: "{n} Unterkünfte in dieser Anlage"
    },
    partOfKind: {
      finca: "Teil der Finca",
      complex: "Teil der Anlage"
    },
    seeAllKind: {
      finca: "Alle {n} Unterkünfte der Finca ansehen",
      complex: "Alle {n} Unterkünfte der Anlage ansehen"
    },
    sharedKind: {
      finca: "Gemeinsame Ausstattung der Finca",
      complex: "Gemeinsame Ausstattung der Anlage"
    },
    reviewsSubtitle: "Bewertungen der Gäste aller Unterkünfte dieser Anlage",
    reviewsKind: {
      finca: "Bewertungen der Gäste aller Unterkünfte dieser Finca",
      complex: "Bewertungen der Gäste aller Unterkünfte dieser Anlage"
    },
    ratingCount: "{n} Bewertungen",
    allPhotos: "Alle {n} Fotos",
    showAllReviews: "Alle {n} Bewertungen anzeigen",
    showLessReviews: "Weniger anzeigen",
    availability: {
      title: "Belegungskalender aller Unterkünfte",
      intro: "Die Zahl zeigt, wie viele der {total} Unterkünfte in der jeweiligen Nacht noch frei sind. Anreise- und Abreisetag anklicken – Sie sehen sofort, welche Unterkünfte im gesamten Zeitraum frei sind.",
      legendAll: "alle frei",
      legendPart: "teilweise frei",
      legendNone: "alles belegt",
      selectHint: "Bitte Anreise- und Abreisetag im Kalender anklicken, um die freien Unterkünfte für Ihren Zeitraum zu sehen.",
      result: "{n} von {total} Unterkünften frei",
      none: "In diesem Zeitraum ist leider keine Unterkunft durchgehend frei – bitte probieren Sie andere Termine.",
      capacity: "zusammen bis {n} Personen",
      inquire: "Diese {n} Unterkünfte anfragen",
      reset: "Zeitraum zurücksetzen"
    },
    group: {
      cta: "Mehrere Unterkünfte anfragen",
      title: {
        finca: "Gruppenanfrage für diese Finca",
        complex: "Gruppenanfrage für diese Anlage"
      },
      intro: "Wählen Sie die gewünschten Unterkünfte, nennen Sie Zeitraum und Personenzahl – wir prüfen die Verfügbarkeit aller Einheiten und melden uns mit einem Angebot.",
      units: "Unterkünfte",
      selected: "{n} ausgewählt",
      capacity: "bis {n} Personen",
      guests: "Personen gesamt",
      send: "Gruppenanfrage senden",
      success: "Vielen Dank! Ihre Gruppenanfrage für {n} Unterkünfte ist eingegangen – wir melden uns in Kürze.",
      minUnits: "Bitte mindestens eine Unterkunft auswählen.",
      messagePlaceholder: "Anlass, Wünsche, flexible Termine …"
    },
    homeSubtitle: "Mehrere Unterkünfte auf einem Grundstück",
    homeTitle: "Fincas & Anlagen für Gruppen und Familien",
    showAll: "Alle Fincas & Anlagen",
    overviewBadge: "Kanarische Inseln · Fincas & Ferienanlagen",
    overviewTitle: "Fincas & Ferienanlagen auf den Kanaren",
    overviewIntro: "Mehrere Ferienwohnungen oder Ferienhäuser auf einem Grundstück – ideal für Familien, Freunde und Gruppen, die zusammen reisen und doch eigene Rückzugsorte haben möchten. Hier finden Sie alle Fincas und Anlagen mit ihren Unterkünften auf einen Blick.",
    overviewSeoTitle: "Fincas & Ferienanlagen auf den Kanaren – privateHOLIDAY",
    overviewMeta: "Alle Fincas und Ferienanlagen mit mehreren Unterkünften auf Teneriffa, Gran Canaria, Fuerteventura, Lanzarote & Co. – privat vermietet, persönlich betreut.",
    kindAll: "Alle",
    kindFincas: "Fincas",
    kindComplexes: "Anlagen",
    allIslands: "Alle Inseln",
    onIsland: "Fincas & Anlagen auf {n}",
    inPlace: "Fincas & Anlagen in {n}",
    unitsShort: "{n} Unterkünfte",
    unitShort: "1 Unterkunft",
    none: "Derzeit sind keine Fincas oder Anlagen online.",
    toKind: {
      finca: "Zur Finca",
      complex: "Zur Anlage"
    },
    priceFromNight: "ab {p} € / Nacht",
    listFilter: "Anlage / Finca",
    listFilterAll: "Alle",
    listChip: {
      finca: "Unterkünfte der Finca",
      complex: "Unterkünfte der Anlage"
    },
    breadcrumb: "Fincas & Anlagen",
    sectionIntro: "Mehrere Unterkünfte auf einem Grundstück – ideal für Gruppen und Familien."
  },
  reviews: {
    title: "Das sagen unsere Gäste",
    subtitle: "Echte Bewertungen nach dem Aufenthalt",
    autoTranslated: "Automatisch übersetzt",
    ownerReply: "Antwort des Vermieters",
    summaryTitle: "Gästestimmen (Zusammenfassung)",
    summaryCount: "Bewertungen",
    qExpectation: "Die Unterkunft entsprach meiner Erwartung",
    qDescription: "Die Beschreibung des Objektes war korrekt",
    qBookAgain: "Ich würde wieder über privateHOLIDAY buchen",
    city: "Wohnort (optional)",
    country: "Land (optional)",
    landlordNote: "Kritik und Verbesserungsvorschläge (optional)",
    landlordNoteHint: "Wird nicht veröffentlicht, sondern nur an den Vermieter weitergeleitet.",
    thanksPending: "Vielen Dank! Ihre Bewertung wird nach kurzer Prüfung veröffentlicht."
  },
  lastMinute: {
    title: "Last-Minute-Angebote",
    subtitle: "Kurzfristig frei – jetzt sparen"
  },
  newSection: {
    title: "Neu bei uns",
    subtitle: "Zuletzt online gegangene Ferienobjekte",
    all: "Alle neuen Objekte ansehen"
  },
  places: {
    title: "Beliebte Orte",
    subtitle: "Ferienwohnungen & Ferienhäuser in den beliebtesten Urlaubsorten",
    link: "Ferienwohnung {n}"
  },
  tips: {
    title: "Reisetipps",
    subtitle: "Wissenswertes für Ihren Kanaren-Urlaub",
    read: "Weiterlesen",
    all: "Alle Reisetipps",
    breadcrumb: "Reisetipps",
    overviewBadge: "Reiseführer & Tipps",
    overviewTitle: "Reisetipps für Ihren Urlaub auf den Kanarischen Inseln",
    overviewIntro: "Strände, Ausflüge, Mietwagen, Wetter und vieles mehr: Hier finden Sie alle Reisetipps und Informationen rund um Ihren Urlaub auf Teneriffa, Gran Canaria, Lanzarote, Fuerteventura, La Palma, La Gomera und El Hierro – zusammengestellt von unserem Team vor Ort.",
    overviewSeoTitle: "Reisetipps Kanaren – Strände, Ausflüge & Infos | privateHOLIDAY",
    overviewMeta: "Alle Reisetipps für die Kanarischen Inseln: Strände, Ausflüge, Mietwagen, Wetter, Essen & Trinken und praktische Infos für Ihren Urlaub auf Teneriffa, Gran Canaria, Lanzarote & Co.",
    allIslands: "Alle Inseln",
    general: "Allgemein",
    forIsland: "Reisetipps für {n}",
    count: "{n} Reisetipps",
    one: "1 Reisetipp",
    showAll: "Alle {n} Reisetipps für {i} anzeigen",
    none: "Derzeit keine Reisetipps vorhanden.",
    allTopics: "Alle Themen",
    topic: "Thema",
    related: "Weitere Reisetipps",
    relatedSub: "Zum Weiterlesen – passend zu diesem Tipp",
    islandTipsSub: "Nach Themen sortiert – Strände, Ausflüge, Anreise und mehr",
    share: "Tipp teilen",
    shareEmail: "E-Mail",
    copyLink: "Link kopieren",
    copied: "Link kopiert",
    shareMore: "Teilen …",
    latest: "Neueste Reisetipps",
    popular: "Meistgelesene Reisetipps",
    views: "{n} Aufrufe",
    topics: {
      beaches: "Strände & Buchten",
      excursions: "Ausflüge & Sehenswürdigkeiten",
      activities: "Sport, Wandern & Freizeit",
      travel: "Anreise & Mietwagen",
      weather: "Wetter & Klima",
      food: "Essen & Trinken",
      family: "Familie & Kinder",
      pets: "Urlaub mit Hund",
      accessible: "Barrierefrei reisen",
      season: "Saison & Last Minute",
      accommodation: "Unterkünfte",
      places: "Orte & Regionen",
      island: "Inselinfos",
      practical: "Praktische Infos"
    }
  },
  faqSection: {
    title: "Häufige Fragen",
    subtitle: "Antworten rund um Buchung & Aufenthalt",
    intro: "Alles Wichtige zu Buchung, Zahlung, Stornierung und Ihrem Urlaub auf den Kanaren – kurz und verständlich beantwortet.",
    seoTitle: "FAQ – Ferienwohnung auf den Kanaren buchen | privateHOLIDAY",
    seoDesc: "Antworten auf die häufigsten Fragen zu Buchung, Zahlung, Stornierung, Inselwahl und Anreise bei privateHOLIDAY – Ferienwohnungen und Ferienhäuser auf den Kanaren direkt vom Vermieter.",
    contactTitle: "Ihre Frage ist nicht dabei?",
    contactText: "Wir helfen persönlich weiter – per E-Mail oder Telefon.",
    contactCta: "Kontakt aufnehmen",
    footer: "FAQ"
  },
  offers: {
    title: "Angebote",
    subtitle: "Aktuelle Aktionen – automatisch im Preis abgezogen",
    forProperty: "Aktuelle Angebote für dieses Objekt",
    view: "Objekte ansehen",
    showAll: "Alle Angebote",
    badge: "Angebot",
    discount: "Angebot",
    travel: "Anreise {from} – {until}",
    bookBy: "buchbar bis {date}",
    book: "buchen",
    pay: "bezahlen",
    kinds: {
      last_minute: "Last Minute",
      free_nights: "Freie Nächte",
      early_bird: "Frühbucher",
      long_stay: "Langzeit",
      gap: "Lücken-Angebot",
      season: "Saison-Special"
    },
    generic: {
      last_minute: "Rabatt bei kurzfristiger Anreise",
      free_nights: "Länger bleiben, weniger Nächte zahlen",
      early_bird: "Rabatt bei frühzeitiger Buchung",
      long_stay: "Rabatt bei längeren Aufenthalten",
      gap: "Rabatt für freie Lücken zwischen zwei Buchungen – auch kürzer als der Mindestaufenthalt",
      season: "Rabatt für Anreisen im Aktionszeitraum"
    },
    hints: {
      last_minute: "bei Anreise innerhalb der nächsten {days} Tage",
      early_bird: "bei Buchung mind. {days} Tage vor Anreise",
      long_stay: "ab {n} Nächten",
      free_nights: "ab {n} Nächten – {free} Nächte geschenkt",
      gap: "für freie Lücken zwischen zwei Buchungen (bis {days} Nächte oder kürzer als der Mindestaufenthalt) – ab {days} Nächten bzw. die ganze Lücke",
      season: "für Anreisen im Aktionszeitraum"
    },
    gapCalendar: "Lücken-Angebot −{p} %: grün markierte Lücken sind günstiger buchbar – ab {n} Nächten bzw. die ganze Lücke, auch unter dem Mindestaufenthalt"
  },
  recent: {
    title: "Zuletzt angesehen",
    subtitle: "Schnell zurückfinden",
    clear: "Alle entfernen",
    remove: "Entfernen"
  },
  gaps: {
    title: "Kurze Lücken – schnell zugreifen",
    nightsLeft: "nur noch {n} Nächte frei",
    nightLeft: "nur noch 1 Nacht frei",
    hint: "Lücken-Angebot: {p} % Rabatt auf den Übernachtungspreis, kurze Aufenthalte möglich.",
    legend: "kurze Lücke – Lücken-Angebot",
    discountLabel: "Lücken-Angebot",
    sectionEyebrow: "Lücken-Angebote",
    sectionTitle: "Nur noch wenige Nächte frei",
    sectionSub: "Kurze freie Zeiträume zwischen zwei Buchungen – {p} % günstiger, auch für Kurzaufenthalte.",
    sectionSubPlain: "Kurze freie Zeiträume zwischen zwei Buchungen – auch für Kurzaufenthalte buchbar.",
    offers: "Angebote"
  },
  similar: {
    title: "Ähnliche Objekte auf der Insel"
  },
  wishlist: {
    title: "Merkliste",
    saved: "gemerkte Objekte",
    clear: "Liste leeren",
    empty: "Noch keine Objekte gemerkt. Klicken Sie auf das Herz bei einem Objekt, um es hier zu vergleichen.",
    browse: "Objekte entdecken",
    compare: "Vergleich",
    island: "Insel",
    type: "Typ",
    location: "Ort",
    week: "Eine Woche ab",
    guests: "Max. Gäste",
    bedrooms: "Schlafzimmer",
    bathrooms: "Bäder",
    rating: "Bewertung",
    instant: "Sofortbuchung",
    open: "Zum Objekt",
    copyLink: "Link kopieren",
    shareEmail: "Per E-Mail teilen",
    shareTitle: "Merkliste teilen",
    yourName: "Ihr Name",
    recipient: "E-Mail des Empfängers",
    message: "Nachricht (optional)",
    send: "Senden",
    sent: "Merkliste an {email} gesendet",
    sendFailed: "Senden fehlgeschlagen",
    fillFields: "Bitte Name und E-Mail angeben",
    copied: "Link kopiert",
    copyManual: "Link kopieren:",
    linkInfo: "Link",
    imported: "Geteilte Merkliste übernommen"
  },
  prices: {
    title: "Preise",
    season: "Saison",
    period: "Zeitraum",
    perNight: "pro Nacht",
    perWeek: "pro Woche",
    standard: "Standardpreis",
    otherPeriods: "alle übrigen Zeiträume",
    perStay: "pro Aufenthalt",
    maxGuests: "Max. Gäste",
    noSeasons: "Keine Saisonpreise hinterlegt – es gilt ganzjährig der Standardpreis.",
    map: "Lageplan",
    gallery: "Bildergalerie",
    minStay: "Mindestaufenthalt",
    night: "Nacht",
    nights: "Nächte",
    deposit: "Kaution",
    depositHint: "(vor Ort, wird zurückerstattet)",
    cleaningOneNight: "eine Tagesmiete",
    stdOccupancy: "im Preis enthalten",
    cleaningWaived: "entfällt ab {n} Nächten"
  },
  extras: {
    title: "Zuschläge",
    extra_person: "Weitere Person",
    child_2: "Kind bis 2 Jahre",
    child_7: "Kind bis 7 Jahre",
    child_12: "Kind bis 12 Jahre",
    crib: "Kinderbett",
    pets: "Haustier",
    wifi: "Internet",
    perNight: "pro Nacht",
    perStay: "einmalig",
    onsite: "vor Ort gegen Gebühr",
    hint: "Zuschläge für Personen gelten über die im Preis enthaltene Belegung hinaus.",
    formTitle: "Kinder, Haustiere & Extras",
    children: "Kinder",
    pet_count: "Haustiere",
    wantCrib: "Kinderbett gewünscht",
    wantWifi: "Internet gewünscht",
    cleaning_extra_person: "Endreinigung je Zusatzperson",
    registration_fee: "Anmeldegebühr",
    tourist_tax: "Tourismussteuer",
    units: {
      person: "pro Person einmalig",
      booking: "pro Buchung",
      person_night: "pro Person & Nacht",
      adult_night: "pro Erwachsenem & Nacht",
      person_stay: "pro Person einmalig",
      stay: "einmalig",
      night: "pro Nacht",
      week: "pro Woche",
      pet_night: "pro Haustier & Nacht",
      pet_week: "pro Haustier & Woche",
      pet_stay: "pro Haustier einmalig",
      kwh: "pro kWh",
      m3: "pro m³",
      liter: "pro Liter"
    },
    onsiteTitle: "Vor Ort zu zahlen",
    onsiteHint: "Diese Kosten rechnet der Vermieter direkt vor Ort ab – sie sind nicht im Buchungspreis enthalten.",
    onsiteItems: {
      final_cleaning: "Endreinigung",
      interim_cleaning: "Zwischenreinigung",
      electricity: "Strom",
      heating: "Heizung",
      pets: "Haustiere",
      ac: "Klimaanlage",
      other: "Sonstiges"
    }
  },
  property: {
    night: "Nacht",
    legendBooked: "belegt",
    legendHalf: "halber Tag: An- bzw. Abreise möglich",
    month: "Monat",
    longtermOnly: "Nur Langzeitvermietung · ab {n} Tagen",
    vvLabel: "Lizenznummer",
    refLabel: "Objekt-Nr.",
    reviewsTab: "Bewertungen",
    weekFrom: "Eine Woche ab {price} €",
    periodTotal: "Gesamt für {n} Nächte: {price} €",
    periodMinNights: "Mindestaufenthalt {n} Nächte – Zeitraum zu kurz",
    priceFrom: "ab",
    showAllAmenities: "Alle {n} Ausstattungsmerkmale anzeigen",
    showLessAmenities: "Weniger anzeigen",
    weekIncl: "inkl. Endreinigung",
    payDeposit: "Anzahlung {pct} % online per Überweisung oder PayPal",
    payRest: "Restbetrag bei Ankunft an den Vermieter.",
    payLandlord: "Die Zahlung klärt der Vermieter direkt mit Ihnen nach der Buchung.",
    guests: "Gäste",
    bedrooms: "Schlafzimmer",
    bathrooms: "Bäder",
    instantBook: "Sofortbuchung",
    newBadge: "Neu",
    newBadgeHint: "Neu bei privateHOLIDAY – seit {date} online",
    lastMinute: "Last Minute",
    lastMinuteHint: "bei Anreise innerhalb der nächsten {days} Tage – wird automatisch im Preis abgezogen",
    daysLeft: "noch {days} Tage",
    endsIn: "Angebot endet in {days} Tagen",
    endsToday: "Angebot endet heute",
    inquire: "Anfrage senden",
    viewDetails: "Details ansehen",
    amenities: "Ausstattung",
    description: "Beschreibung",
    availability: "Verfügbarkeit",
    priceCalendarNote: "Preis pro Nacht (Saisonpreise berücksichtigt), zzgl. Endreinigung. Belegte Tage sind ausgegraut.",
    total: "Gesamt",
    nights: "Nächte",
    cleaning: "Endreinigung",
    extraCosts: "Servicegebühr",
    book: "Jetzt sofort buchen",
    inquireBtn: "Unverbindliche Anfrage",
    loading: "Lädt…",
    notFound: "Objekt nicht gefunden"
  },
  filters: {
    title: "Filter",
    island: "Insel",
    region: "Region",
    all: "Alle",
    type: "Objekttyp",
    amenities: "Ausstattungswünsche",
    moreAmenities: "mehr Auswahl",
    apartment: "Ferienwohnung",
    villa: "Ferienhaus",
    studio: "Studio",
    finca: "Finca",
    cottage: "Landhaus",
    guests: "Gäste",
    maxPrice: "Max. Preis / Nacht",
    lastMinute: "Nur Last-Minute-Angebote",
    longterm: "Nur Langzeitmiete",
    newOnly: "Nur neue Objekte",
    apply: "Anwenden",
    reset: "Zurücksetzen",
    refSearch: "Objekt-Nr. suchen",
    viewList: "Kacheln",
    viewRows: "Untereinander",
    viewMap: "Karte",
    refNotFound: "Keine Unterkunft mit dieser Objekt-Nr. gefunden",
    results: "Ergebnisse",
    freeFor: "frei vom",
    sort: "Sortieren",
    sortRecommended: "Empfohlen",
    sortPriceAsc: "Preis aufsteigend",
    sortPriceDesc: "Preis absteigend",
    sortRating: "Beste Bewertung",
    sortNewest: "Neueste"
  },
  booking: {
    voucherLabel: "Gutscheincode",
    voucherApply: "Einlösen",
    voucherPlaceholder: "Code eingeben",
    voucherRow: "Gutschein {code}",
    voucherErr: {
      expired: "Gutschein ist abgelaufen oder noch nicht gültig",
      exhausted: "Gutschein wurde bereits vollständig eingelöst",
      wrong_property: "Gutschein gilt nicht für dieses Objekt",
      invalid: "Gutscheincode ungültig",
      not_new: "Der Gutschein gilt nur für Neukunden (erste Buchung)",
      min_nights: "Gutschein gilt ab {n} Nächten",
      min_total: "Gutschein gilt ab {n} € Buchungswert",
      email_required: "Bitte zuerst Ihre E-Mail eingeben"
    },
    voucherOk: "Gutschein eingelöst: −{n} €",
    title: "Sofortbuchung",
    inquiryTitle: "Anfrage senden",
    name: "Vollständiger Name",
    email: "E-Mail",
    phone: "Telefon (optional)",
    phoneReq: "Telefon (mit Landesvorwahl)",
    address: "Adresse",
    addressHint: "Straße Nr., PLZ Ort, Land",
    salutation: "Anrede",
    salutationNone: "Keine Angabe",
    mr: "Herr",
    mrs: "Frau",
    firstName: "Vorname",
    lastName: "Nachname",
    street: "Straße und Hausnummer",
    zip: "PLZ",
    city: "Ort",
    country: "Land",
    fillAll: "Bitte alle Pflichtfelder (*) ausfüllen",
    message: "Nachricht",
    messageOptional: "Nachricht (optional)",
    submit: "Buchung bestätigen",
    submitInquiry: "Anfrage abschicken",
    success: "Buchung bestätigt! Bestätigung per E-Mail unterwegs.",
    inquirySuccess: "Anfrage gesendet. Wir melden uns bald bei Ihnen.",
    smsSent: "SMS an Vermieter wurde ausgelöst",
    error: "Etwas ist schiefgelaufen",
    selectDates: "Bitte Datum auswählen",
    minNights: "Mindestaufenthalt in diesem Zeitraum: {n} Nächte",
    minStayChosen: "Sie haben {c} gewählt",
    minStayShort: "Mindestaufenthalt {n} Nächte – {c} gewählt",
    setCheckout: "Abreise auf {date} setzen",
    fixCheckout: "Abreise anpassen",
    minStayHint: "Anreise {date} · Mindestaufenthalt {n} Nächte – Abreise ab {to} möglich",
    minStayBlocked: "Für {n} Nächte ab {date} ist das Objekt leider nicht frei – bitte eine andere Anreise wählen.",
    persons: "Personen",
    adult: "Erwachsener",
    adults: "Erwachsene",
    child: "Kind",
    children: "Kinder",
    maxGuests: "Maximal {n} Personen",
    selectPeriod: "Zeitraum wählen für aktuelle Preise",
    noCharge: "Keine Sorge – mit diesem Klick wird noch nichts bezahlt.",
    bookNow: "Jetzt buchen",
    perNightShort: "× {n} Nächte",
    stepGuests: "Gäste",
    stepDone: "Fertig",
    pageTitle: "Einzelheiten zur Reservierung",
    pageTitleInquiry: "Einzelheiten zur Anfrage",
    contact: "Kontaktinformation",
    emailHint: "Wir senden die Bestätigung per E-Mail",
    phoneHint: "Bei Fragen meldet sich der Vermieter telefonisch",
    personal: "Persönliche Angaben",
    specialTitle: "Besondere Anfragen",
    specialHint: "Stellen Sie hier Ihre Fragen oder Wünsche. Der Vermieter tut sein Möglichstes, um sie zu erfüllen.",
    priceDetails: "Preisdetails",
    totalPrice: "Gesamtpreis",
    included: "Im Gesamtpreis inbegriffen",
    tripTitle: "Reisezeitraum & Personen",
    thanks: "Vielen Dank!",
    bookingNo: "Buchungsnummer",
    backToProperty: "Zurück zum Objekt",
    nextSteps: "So geht es weiter",
    nextStepsBooking: "Sie erhalten in Kürze eine Bestätigung per E-Mail mit allen Angaben zur Anzahlung. Der Restbetrag wird bei Ankunft an den Vermieter gezahlt.",
    nextStepsInquiry: "Der Vermieter prüft Ihre Anfrage und meldet sich in der Regel innerhalb von 24 Stunden per E-Mail oder Telefon."
  },
  admin: {
    title: "Admin Bereich",
    login: "Anmelden",
    email: "E-Mail",
    password: "Passwort",
    properties: "Objekte",
    bookings: "Buchungen",
    inquiries: "Anfragen",
    sms: "SMS-Log",
    logout: "Abmelden",
    addProperty: "Objekt hinzufügen",
    status: "Status",
    confirmed: "Bestätigt",
    pending: "Ausstehend",
    cancelled: "Storniert",
    guest: "Gast",
    dates: "Zeitraum",
    total: "Betrag",
    actions: "Aktionen",
    delete: "Löschen",
    edit: "Bearbeiten"
  },
  gallery: {
    exterior: "Außenansicht",
    pool: "Pool / Terrasse / Garten",
    view: "Ausblick",
    living: "Wohnbereich",
    kitchen: "Küche",
    bedroom: "Schlafzimmer",
    bathroom: "Bad",
    surroundings: "Umgebung",
    open: "Galerie öffnen"
  },
  footer: {
    tagline: "Kanaren-Ferien mit Herz",
    rights: "Alle Rechte vorbehalten",
    blog: "Blog",
    ical: "iCal-Service",
    follow: "Folgen Sie uns",
    landlord: "Vermieter-Login",
    wishlist: "Merkliste",
    service: "Service",
    brand: "privateHOLIDAY",
    islands: "Die acht Inseln",
    tips: "Reisetipps"
  },
  offlineNotice: {
    text: "Dieses Objekt ist nicht mehr buchbar – hier finden Sie ähnliche Unterkünfte in {n}.",
    cta: "Ähnliche Unterkünfte ansehen"
  },
  notFound: {
    title: "Seite nicht gefunden – privateHOLIDAY",
    h1: "Diese Seite gibt es leider nicht",
    text: "Die Adresse ist falsch geschrieben, veraltet oder die Seite wurde entfernt. Vielleicht hilft Ihnen einer dieser Wege weiter:",
    home: "Zur Startseite",
    properties: "Alle Ferienobjekte",
    island: "Ferienobjekte auf {n}",
    search: "Objekt-Nr. oder Ort suchen"
  },
  homepage: {
    sections: { about: "Über uns", properties: "Unsere Unterkünfte", gallery: "Galerie", location: "Lage & Karte", reviews: "Bewertungen", faq: "Häufige Fragen", newsletter: "Newsletter", contact: "Kontakt" },
    newsletter: {
      intro: "Neuigkeiten, freie Termine und Angebote von {name} – direkt per E-Mail. Jederzeit abbestellbar.",
      email: "Ihre E-Mail-Adresse", name: "Ihr Name (optional)", button: "Anmelden",
      terms: "Ich möchte den Newsletter erhalten und bin einverstanden, dass meine E-Mail-Adresse dafür gespeichert wird.",
      sent: "Fast geschafft!", sentText: "Wir haben Ihnen eine E-Mail geschickt – bitte bestätigen Sie Ihre Anmeldung über den Link darin.",
      already: "Sie sind bereits angemeldet.", confirmed: "Vielen Dank – Ihre Newsletter-Anmeldung ist bestätigt.", unsubscribed: "Sie wurden vom Newsletter abgemeldet.", linkInvalid: "Dieser Link ist ungültig oder wurde bereits verwendet."
    },
    index: {
      title: "Ferienunterkünfte direkt vom Vermieter", sub: "{sites} Vermieter · {props} Unterkünfte – jede Homepage persönlich gestaltet, Buchung sicher über privateHOLIDAY.",
      open: "Homepage ansehen", props: "Unterkünfte", reviews: "Bewertungen", empty: "Hier erscheinen in Kürze die ersten Vermieter-Homepages.", more: "Alle Ferienobjekte auf privateHOLIDAY"
    },
    ctaProperties: "Unterkünfte ansehen",
    ctaContact: "Kontakt aufnehmen",
    reviewsCount: "Bewertungen",
    noProperties: "Derzeit sind keine Unterkünfte online.",
    contactIntro: "Sie erreichen {name} direkt – oder senden Sie uns eine Anfrage über das Formular.",
    bookingNote: "Anfragen und Buchungen werden sicher abgewickelt über",
    poweredBy: "Homepage bereitgestellt von",
    moreProperties: "Weitere Ferienobjekte auf den Kanaren",
    cookies: "Cookie-Einstellungen",
    imprint: "Impressum",
    previewBanner: "Vorschau – diese Homepage ist noch nicht veröffentlicht.",
    form: {
      property: "Unterkunft", salutation: "Anrede", mr: "Herr", mrs: "Frau", name: "Ihr Name", email: "E-Mail", phone: "Telefon (optional)", guests: "Personen", message: "Ihre Nachricht (Reisezeitraum, Wünsche …)",
      terms: "Ich bin damit einverstanden, dass meine Angaben zur Bearbeitung der Anfrage gespeichert und an den Vermieter weitergegeben werden.",
      termsRequired: "Bitte der Datenverarbeitung zustimmen.", send: "Anfrage senden", error: "Senden fehlgeschlagen – bitte später erneut versuchen.",
      thanks: "Vielen Dank für Ihre Anfrage!", thanksText: "Wir melden uns so schnell wie möglich per E-Mail."
    }
  },
  propertiesSeo: {
    where: "den Kanaren",
    what: {
      all: "Ferienobjekte",
      apartment: "Ferienwohnungen",
      studio: "Studios & Apartments",
      villa: "Ferienhäuser & Villen",
      finca: "Fincas"
    },
    title: "{what} auf {where} – privat mieten",
    desc: "{what} auf {where} im Überblick – privat, direkt vom Vermieter, ohne Portalgebühren. Verfügbarkeit prüfen, online anfragen oder sofort buchen."
  }
};
